import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ReloadOutlined } from '@ant-design/icons';
import * as S from './TimeoutErrorBubble.styles';

interface TimeoutErrorBubbleProps {
  onRefresh: () => void;
}

const TimeoutErrorBubble: React.FC<TimeoutErrorBubbleProps> = observer(({ onRefresh }) => {
  const { t } = useTranslation();

  return (
    <S.ErrorBubbleContainer>
      <S.ErrorIcon>⚠️</S.ErrorIcon>
      <S.ErrorContent>
        <S.ErrorMessage>{t('SocketResponseTimeoutError')}</S.ErrorMessage>
        <S.RefreshButton onClick={onRefresh} type="button">
          <ReloadOutlined />
          <span>{t('ResendMessage')}</span>
        </S.RefreshButton>
      </S.ErrorContent>
    </S.ErrorBubbleContainer>
  );
});

TimeoutErrorBubble.displayName = 'TimeoutErrorBubble';

export default TimeoutErrorBubble;
